import React from "react";
import { Container } from "./styles";
export var Tooltip = function (_a) {
    var content = _a.content, show = _a.show, containerStyles = _a.containerStyles, targetRef = _a.targetRef;
    return (React.createElement(Container, { style: containerStyles, show: show, targetRef: targetRef }, content));
};
//# sourceMappingURL=index.js.map